import * as _tslib2 from "tslib";
var _tslib = _tslib2;
try {
  if ("default" in _tslib2) _tslib = _tslib2.default;
} catch (e) {}
import _ethers from "./ethers.js";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ethers = void 0;
const tslib_1 = _tslib;
/**
 *  The Application Programming Interface (API) is the collection of
 *  functions, classes and types offered by the Ethers library.
 *
 *  @_section: api:Application Programming Interface  [about-api]
 *  @_navTitle: API
 */
const ethers = tslib_1.__importStar(_ethers);
exports.ethers = ethers;
tslib_1.__exportStar(_ethers, exports);
//# sourceMappingURL=index.js.map
export default exports;
export const __esModule = exports.__esModule,
  ripemd160 = exports.ripemd160,
  keccak256 = exports.keccak256,
  randomBytes = exports.randomBytes,
  computeHmac = exports.computeHmac,
  UndecodedEventLog = exports.UndecodedEventLog,
  EventLog = exports.EventLog,
  ContractUnknownEventPayload = exports.ContractUnknownEventPayload,
  ContractTransactionResponse = exports.ContractTransactionResponse,
  ContractTransactionReceipt = exports.ContractTransactionReceipt,
  ContractEventPayload = exports.ContractEventPayload,
  ContractFactory = exports.ContractFactory,
  Contract = exports.Contract,
  BaseContract = exports.BaseContract,
  MessagePrefix = exports.MessagePrefix,
  EtherSymbol = exports.EtherSymbol,
  ZeroHash = exports.ZeroHash,
  N = exports.N,
  MaxInt256 = exports.MaxInt256,
  MinInt256 = exports.MinInt256,
  MaxUint256 = exports.MaxUint256,
  WeiPerEther = exports.WeiPerEther,
  ZeroAddress = exports.ZeroAddress,
  resolveAddress = exports.resolveAddress,
  isAddress = exports.isAddress,
  isAddressable = exports.isAddressable,
  getCreate2Address = exports.getCreate2Address,
  getCreateAddress = exports.getCreateAddress,
  getIcapAddress = exports.getIcapAddress,
  getAddress = exports.getAddress,
  Typed = exports.Typed,
  TransactionDescription = exports.TransactionDescription,
  Result = exports.Result,
  LogDescription = exports.LogDescription,
  Interface = exports.Interface,
  Indexed = exports.Indexed,
  ErrorDescription = exports.ErrorDescription,
  checkResultErrors = exports.checkResultErrors,
  StructFragment = exports.StructFragment,
  ParamType = exports.ParamType,
  NamedFragment = exports.NamedFragment,
  FunctionFragment = exports.FunctionFragment,
  FallbackFragment = exports.FallbackFragment,
  Fragment = exports.Fragment,
  EventFragment = exports.EventFragment,
  ErrorFragment = exports.ErrorFragment,
  ConstructorFragment = exports.ConstructorFragment,
  AbiCoder = exports.AbiCoder,
  encodeBytes32String = exports.encodeBytes32String,
  decodeBytes32String = exports.decodeBytes32String,
  version = exports.version,
  EnsPlugin = exports.EnsPlugin,
  Network = exports.Network,
  EnsResolver = exports.EnsResolver,
  WebSocketProvider = exports.WebSocketProvider,
  SocketProvider = exports.SocketProvider,
  IpcSocketProvider = exports.IpcSocketProvider,
  QuickNodeProvider = exports.QuickNodeProvider,
  PocketProvider = exports.PocketProvider,
  InfuraWebSocketProvider = exports.InfuraWebSocketProvider,
  InfuraProvider = exports.InfuraProvider,
  EtherscanProvider = exports.EtherscanProvider,
  CloudflareProvider = exports.CloudflareProvider,
  ChainstackProvider = exports.ChainstackProvider,
  AnkrProvider = exports.AnkrProvider,
  AlchemyProvider = exports.AlchemyProvider,
  BrowserProvider = exports.BrowserProvider,
  JsonRpcSigner = exports.JsonRpcSigner,
  JsonRpcProvider = exports.JsonRpcProvider,
  JsonRpcApiProvider = exports.JsonRpcApiProvider,
  FallbackProvider = exports.FallbackProvider,
  AbstractProvider = exports.AbstractProvider,
  VoidSigner = exports.VoidSigner,
  NonceManager = exports.NonceManager,
  AbstractSigner = exports.AbstractSigner,
  TransactionResponse = exports.TransactionResponse,
  TransactionReceipt = exports.TransactionReceipt,
  Log = exports.Log,
  FeeData = exports.FeeData,
  Block = exports.Block,
  getDefaultProvider = exports.getDefaultProvider,
  verifyTypedData = exports.verifyTypedData,
  TypedDataEncoder = exports.TypedDataEncoder,
  solidityPackedSha256 = exports.solidityPackedSha256,
  solidityPackedKeccak256 = exports.solidityPackedKeccak256,
  solidityPacked = exports.solidityPacked,
  verifyMessage = exports.verifyMessage,
  hashMessage = exports.hashMessage,
  dnsEncode = exports.dnsEncode,
  namehash = exports.namehash,
  isValidName = exports.isValidName,
  ensNormalize = exports.ensNormalize,
  id = exports.id,
  SigningKey = exports.SigningKey,
  Signature = exports.Signature,
  lock = exports.lock,
  scryptSync = exports.scryptSync,
  scrypt = exports.scrypt,
  pbkdf2 = exports.pbkdf2,
  sha512 = exports.sha512,
  sha256 = exports.sha256,
  getUint = exports.getUint,
  getNumber = exports.getNumber,
  getBigInt = exports.getBigInt,
  FixedNumber = exports.FixedNumber,
  FetchCancelSignal = exports.FetchCancelSignal,
  FetchResponse = exports.FetchResponse,
  FetchRequest = exports.FetchRequest,
  EventPayload = exports.EventPayload,
  isError = exports.isError,
  isCallException = exports.isCallException,
  makeError = exports.makeError,
  assertPrivate = exports.assertPrivate,
  assertNormalize = exports.assertNormalize,
  assertArgumentCount = exports.assertArgumentCount,
  assertArgument = exports.assertArgument,
  assert = exports.assert,
  resolveProperties = exports.resolveProperties,
  defineProperties = exports.defineProperties,
  zeroPadValue = exports.zeroPadValue,
  zeroPadBytes = exports.zeroPadBytes,
  stripZerosLeft = exports.stripZerosLeft,
  isBytesLike = exports.isBytesLike,
  isHexString = exports.isHexString,
  hexlify = exports.hexlify,
  getBytesCopy = exports.getBytesCopy,
  getBytes = exports.getBytes,
  dataSlice = exports.dataSlice,
  dataLength = exports.dataLength,
  concat = exports.concat,
  encodeBase64 = exports.encodeBase64,
  decodeBase64 = exports.decodeBase64,
  encodeBase58 = exports.encodeBase58,
  decodeBase58 = exports.decodeBase58,
  Transaction = exports.Transaction,
  recoverAddress = exports.recoverAddress,
  computeAddress = exports.computeAddress,
  accessListify = exports.accessListify,
  showThrottleMessage = exports.showThrottleMessage,
  copyRequest = exports.copyRequest,
  UnmanagedSubscriber = exports.UnmanagedSubscriber,
  SocketSubscriber = exports.SocketSubscriber,
  SocketPendingSubscriber = exports.SocketPendingSubscriber,
  SocketEventSubscriber = exports.SocketEventSubscriber,
  SocketBlockSubscriber = exports.SocketBlockSubscriber,
  MulticoinProviderPlugin = exports.MulticoinProviderPlugin,
  NetworkPlugin = exports.NetworkPlugin,
  GasCostPlugin = exports.GasCostPlugin,
  FetchUrlFeeDataNetworkPlugin = exports.FetchUrlFeeDataNetworkPlugin,
  FeeDataNetworkPlugin = exports.FeeDataNetworkPlugin,
  EtherscanPlugin = exports.EtherscanPlugin,
  wordlists = exports.wordlists,
  WordlistOwlA = exports.WordlistOwlA,
  WordlistOwl = exports.WordlistOwl,
  LangEn = exports.LangEn,
  Wordlist = exports.Wordlist,
  encryptKeystoreJsonSync = exports.encryptKeystoreJsonSync,
  encryptKeystoreJson = exports.encryptKeystoreJson,
  decryptKeystoreJson = exports.decryptKeystoreJson,
  decryptKeystoreJsonSync = exports.decryptKeystoreJsonSync,
  decryptCrowdsaleJson = exports.decryptCrowdsaleJson,
  isKeystoreJson = exports.isKeystoreJson,
  isCrowdsaleJson = exports.isCrowdsaleJson,
  getIndexedAccountPath = exports.getIndexedAccountPath,
  getAccountPath = exports.getAccountPath,
  defaultPath = exports.defaultPath,
  Wallet = exports.Wallet,
  HDNodeVoidWallet = exports.HDNodeVoidWallet,
  HDNodeWallet = exports.HDNodeWallet,
  BaseWallet = exports.BaseWallet,
  Mnemonic = exports.Mnemonic,
  uuidV4 = exports.uuidV4,
  encodeRlp = exports.encodeRlp,
  decodeRlp = exports.decodeRlp,
  Utf8ErrorFuncs = exports.Utf8ErrorFuncs,
  toUtf8String = exports.toUtf8String,
  toUtf8CodePoints = exports.toUtf8CodePoints,
  toUtf8Bytes = exports.toUtf8Bytes,
  parseUnits = exports.parseUnits,
  formatUnits = exports.formatUnits,
  parseEther = exports.parseEther,
  formatEther = exports.formatEther,
  mask = exports.mask,
  toTwos = exports.toTwos,
  fromTwos = exports.fromTwos,
  toQuantity = exports.toQuantity,
  toNumber = exports.toNumber,
  toBeHex = exports.toBeHex,
  toBigInt = exports.toBigInt,
  toBeArray = exports.toBeArray;
const _ethers2 = exports.ethers;
export { _ethers2 as ethers };